import "../index.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer
      className="mt-5"
      id="hidethis"
      style={{
        backgroundColor: "#f8f9fa",
        borderTop: "3px solid #8B0000",
        paddingTop: "40px",
        paddingBottom: "25px",
      }}
    >
      <div id="hidethis" className="container">
        {/* Main Footer Content */}
        <div className="row g-4 mb-4">
          {/* Company Info Section */}
          <div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0 footer-company-section">
            <Link
              to="/"
              className="d-block mb-2 footer-logo"
              style={{ transition: "transform 0.3s ease", textDecoration: "none" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            >
              <img
                src={`${process.env.PUBLIC_URL}/hosteladminlogo.png`}
                style={{ height: "45px", width: "auto", display: "block" }}
                alt="Hostel Duniya Logo"
              />
            </Link>
            <p
              className="mb-2 footer-tagline"
              style={{
                color: "#666",
                fontSize: "14px",
                lineHeight: "1.6",
                maxWidth: "300px",
                textAlign: "left",
              }}
            >
              Connecting hostel owners with students. Your trusted platform for hostel management and lead generation.
            </p>
          </div>

          {/* Legal Section */}
          <div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0 footer-legal-section">
            <h5
              className="fw-bold mb-2 footer-section-heading"
              style={{ 
                color: "#760B0B", 
                fontSize: "17px",
                textAlign: "left",
                marginLeft: "0",
                paddingLeft: "0"
              }}
            >
              Legal
            </h5>
            <ul
              className="list-unstyled footer-legal-list"
              style={{ padding: 0, margin: 0, textAlign: "left" }}
            >
              <li className="mb-2" style={{ paddingLeft: "0" }}>
                <Link
                  to="/privacy-policy"
                  className="text-decoration-none d-inline-block"
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => e.target.style.color = "#8B0000"}
                  onMouseLeave={(e) => e.target.style.color = "#666"}
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="mb-2" style={{ paddingLeft: "0" }}>
                <Link
                  to="/terms-and-conditions"
                  className="text-decoration-none d-inline-block"
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => e.target.style.color = "#8B0000"}
                  onMouseLeave={(e) => e.target.style.color = "#666"}
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="col-12 col-md-6 col-lg-4 footer-contact-section">
            <h5
              className="fw-bold mb-2 footer-section-heading"
              style={{ 
                color: "#760B0B", 
                fontSize: "17px",
                textAlign: "left",
                marginLeft: "0",
                paddingLeft: "0"
              }}
            >
              Contact Us
            </h5>
            <ul
              className="list-unstyled footer-contact-list"
              style={{ padding: 0, margin: 0, textAlign: "left" }}
            >
              <li className="mb-2 d-flex align-items-start" style={{ paddingLeft: "0" }}>
                <span className="me-2" style={{ color: "#8B0000", fontSize: "15px", flexShrink: 0 }}>📧</span>
                <a
                  href="mailto:hostelduniya24@gmail.com"
                  className="text-decoration-none"
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    transition: "color 0.3s ease",
                    wordBreak: "break-word",
                  }}
                  onMouseEnter={(e) => e.target.style.color = "#8B0000"}
                  onMouseLeave={(e) => e.target.style.color = "#666"}
                >
                  hostelduniya24@gmail.com
                </a>
              </li>
              <li className="mb-2 d-flex align-items-start" style={{ paddingLeft: "0" }}>
                <span className="me-2" style={{ color: "#8B0000", fontSize: "15px", flexShrink: 0 }}>📞</span>
                <a
                  href="tel:7678134697"
                  className="text-decoration-none"
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => e.target.style.color = "#8B0000"}
                  onMouseLeave={(e) => e.target.style.color = "#666"}
                >
                  7678134697
                </a>
              </li>
              <li className="mb-2 d-flex align-items-start" style={{ paddingLeft: "0" }}>
                <span className="me-2" style={{ color: "#8B0000", fontSize: "15px", flexShrink: 0 }}>📍</span>
                <span
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  B-116 Rajiv Nagar Budh Bazar
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <hr
          style={{
            borderColor: "#e0e0e0",
            margin: "25px 0 18px 0",
            opacity: "0.5",
          }}
        />

        {/* Copyright Section */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center text-center text-md-start gap-1 footer-copyright-section">
              <p
                className="mb-0 footer-copyright"
                style={{
                  fontSize: "13px",
                  color: "#666",
                  lineHeight: "1.6",
                }}
              >
                2026 &copy; <strong style={{ color: "#760B0B" }}>HostelDuniya™</strong> Ltd. All rights reserved.
              </p>
              <p
                className="mb-0 footer-disclaimer"
                style={{
                  fontSize: "12px",
                  color: "#999",
                  lineHeight: "1.6",
                }}
              >
                By continuing, you agree to our Terms of Service, Cookie Policy, and Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
